module.exports = __webpack_public_path__ + "static/media/music.04fddc0e.jpg";